import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { sendEmails } from "../../utils/Network";

/**
 * Reusable compose form (same behaviour as /cms/email) — to, subject, HTML body.
 * Used inside modals or full pages.
 */
export default function SendEmailComposeWidget({
  toEmail,
  onCancel,
  onSent,
  className = "",
}) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSend = () => {
    setError(null);

    const addr = toEmail && String(toEmail).trim();
    if (!addr) {
      setError("Recipient email is missing");
      return;
    }
    if (!subject || !String(subject).trim()) {
      setError("Please enter subject");
      return;
    }
    if (!message || !String(message).trim()) {
      setError("Please enter message");
      return;
    }

    setLoading(true);
    sendEmails([addr], null, subject.trim(), message)
      .then((data) => {
        setLoading(false);
        setSubject("");
        setMessage("");
        if (onSent) onSent(data);
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to send email");
      });
  };

  return (
    <div className={`send-email-compose-widget ${className}`}>
      <div className="form-group">
        <label className="control-label send-email-compose-label">To</label>
        <input
          type="text"
          readOnly
          value={toEmail || ""}
          className="form-control send-email-compose-input"
        />
      </div>
      <div className="form-group">
        <label className="control-label send-email-compose-label">Subject</label>
        <input
          type="text"
          value={subject}
          name="subject"
          onChange={(e) => setSubject(e.target.value)}
          className="form-control send-email-compose-input post-title"
          placeholder="Subject"
        />
      </div>
      <div className="form-group mb-12">
        <label className="control-label send-email-compose-label">Message</label>
        <CKEditor
          editor={ClassicEditor}
          data={message}
          onChange={(event, editor) => {
            setMessage(editor.getData());
          }}
        />
      </div>
      {error && <div className="alert alert-danger mt-5">{error}</div>}
      {loading && <div className="alert alert-info mt-5">Please wait…</div>}
      <div className="send-email-compose-actions">
        <button type="button" className="btn btn-cm" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-cm"
          onClick={handleSend}
          disabled={loading}
        >
          Send email
        </button>
      </div>
    </div>
  );
}
